var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "url(#paint0_linear_1316_105)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H7V12H15V10Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_105",
    x1: 12.4474,
    y1: -4.92105,
    x2: 11,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF03CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0CB2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-minus.3a43a2b47974dfc0e5480f62d798a182.svg";